import CitySEOHead from "@/components/feature/CitySEOHead";
import AuburnHeroSection from "./components/HeroSection";
import AuburnStickyNav from "./components/StickyNav";
import AuburnProcessingTimeSection from "./components/ProcessingTimeSection";
import AuburnServicesSection from "./components/ServicesSection";
import AuburnLocalAreaSection from "./components/LocalAreaSection";
import AuburnTravelTimingSection from "./components/TravelTimingSection";
import AuburnDestinationsSection from "./components/DestinationsSection";
import AuburnTestimonialsSection from "./components/TestimonialsSection";
import AuburnAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AuburnComparisonSection from "./components/ComparisonSection";
import AuburnMistakesSection from "./components/MistakesSection";
import AuburnHowItWorksSection from "./components/HowItWorksSection";
import AuburnFAQSection, { faqs } from "./components/FAQSection";
import AuburnHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AuburnFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const auburnFaqs = faqs as { q: string; a: string }[];

const auburnServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AuburnPage() {
  return (
    <>
      <CitySEOHead
        city="Auburn"
        state="Alabama"
        stateAbbr="AL"
        route="/cities/auburn"
        title="Emergency Passport Auburn, AL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Auburn, AL — as fast as 24 hours. Auburn University students, faculty, and Lee County residents served. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Auburn, Alabama"
        geoPosition="32.6099;-85.4808"
        faqs={auburnFaqs}
        servicesSchema={auburnServices}
        statePageName="Alabama"
        statePageRoute="/states/alabama"
      />
      <div className="font-sans">
        <AuburnHeroSection />
        <AuburnStickyNav />
        <AuburnProcessingTimeSection />
        <AuburnLocalAreaSection />
        <AuburnServicesSection />
        <AuburnTravelTimingSection />
        <AuburnDestinationsSection />
        <AuburnTestimonialsSection />
        <AuburnAcceptanceFacilitiesSection />
        <AuburnComparisonSection />
        <AuburnMistakesSection />
        <AuburnHowItWorksSection />
        <AuburnFAQSection />
        <AuburnHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/auburn" state="AL" />
        <AuburnFinalCTA />
      </div>
    </>
  );
}